import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as toastrReducer } from 'react-redux-toastr';
import { ssgFormsReducer } from '@social-solutions/ssg-forms';
import { authReducer, heartbeatReducer } from './auth';
import { loginReducer } from './login';
import { touchpointsReducer } from './touchpoints';
import { responsesReducer } from './responses';
import { changeEmailReducer, changePasswordReducer, forgotPasswordReducer, resetPasswordReducer } from './acct';
import { settingsReducer } from './common';
import { titleReducer, layoutReducer } from './layout';
import { programEnrollmentReducer, programReducer } from './programs';
import { messagesReducer } from './dashboard';
import { accessibilityNotificationReducer } from './common';
import { tenantReducer } from './tenantInfo';
import { demographicsReducer } from './demographics';
import { intakeReducer } from './intake';
import { optOutReducer } from './acct/opt-out';
import { surveyReducer } from './survey';
import { myScheduleReducer, appointmentDetailsReducer } from './scheduler';

const rootReducer = combineReducers({
  toastr: toastrReducer,
  accessibilityNotifications : accessibilityNotificationReducer,
  auth: authReducer,
  heartbeat: heartbeatReducer,
  tenant: tenantReducer,
  login: loginReducer,
  touchpoints: touchpointsReducer,
  responses: responsesReducer,
  routing: routerReducer,
  changeEmail: changeEmailReducer,
  changePassword: changePasswordReducer,
  settings: settingsReducer,
  title: titleReducer,
  layout: layoutReducer,
  forgotPassword: forgotPasswordReducer,
  resetPassword: resetPasswordReducer,
  programEnrollment: programEnrollmentReducer,
  programs: programReducer,
  dashboardMessages: messagesReducer,
  demographics: demographicsReducer,
  intake: intakeReducer,
  survey: surveyReducer,
  ssgForms: ssgFormsReducer,
  optOut: optOutReducer,
  appointments: myScheduleReducer,
  appointmentDetails: appointmentDetailsReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// src/root-reducer.js